import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback, FormGroup, FormText } from "reactstrap";
import Select from "react-select";
import { getAgencies } from "common/services/agencies.service";
import { normalize } from "common/lib/normalize";

const FIELD = "agencies";

/**
 * The UN agencies drawing on the agreement besides the lead agency, which is
 * the one that established it.
 */
const SelectAgencies = ({
  validation,
  label = "Other Agencies using this LTA",
  helpText,
}: {
  validation: any;
  label?: string;
  helpText?: string;
}) => {
  const invalid = validation.touched[FIELD] && validation.errors[FIELD];

  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor: invalid ? "red" : "#ced4da",
      "&:hover": { borderColor: invalid ? "red" : "#ced4da" },
    }),
  };

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response: any = await getAgencies({
          pagination: { page: 1, pageSize: 10000 },
          filters: { category: { $null: false } },
          sort: ["name"],
        });
        setData(normalize(response.data));
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const options = useMemo(
    () => data.map((el: any) => ({ value: el?.id, label: el?.name })),
    [data]
  );

  return (
    <FormGroup className="mb-0">
      <Label htmlFor="agencies-field" className="form-label">
        {label}
      </Label>
      <Select
        isMulti
        name={FIELD}
        id={FIELD}
        value={validation.values[FIELD] || []}
        isSearchable
        placeholder="Select agencies"
        onChange={(value: any) => {
          validation.setFieldValue(FIELD, value || []);
          validation.setFieldError(FIELD, "");
        }}
        options={options}
        onBlur={() => validation.setFieldTouched(FIELD, true)}
        className={invalid ? "is-invalid" : ""}
        styles={customSelectStyles}
        isLoading={loading}
        closeMenuOnSelect={false}
      />
      {helpText && <FormText>{helpText}</FormText>}
      <FormFeedback>{validation.errors[FIELD]}</FormFeedback>
    </FormGroup>
  );
};

export default SelectAgencies;
